import { bannerListApi, bidHotApi, searchResultApi, searchHotApi } from '@/api/index/index'
import { STATIC_VIEW } from '@/api/static_api'
// initial state
const state = {
  bannerList: [],
  bidHot: {},
  searchResultNotary: {},
  searchResultNotaryList: [],
  searchResultArticle: {},
  searchResultArticleList: [],
  searchHot: []
}

// getters
const getters = {}

// actions
const actions = {
  // 获取Banner
  bannerListAction ({ commit }) {
    return new Promise((resolve, reject) => {
      bannerListApi().then(response => {
        let bannerList = []
        if (response.status === '2000') {
          response.data.forEach(banner => {
            if (banner.img && banner.img.length > 0) {
              banner.img = STATIC_VIEW + banner.img
              bannerList.push(banner)
            }
          })
          commit('setBannerList', bannerList)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取热门申办
  bidHotAction ({ commit }) {
    return new Promise((resolve, reject) => {
      bidHotApi().then(response => {
        if (response.status === '2000') {
          commit('setBidHot', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 搜索公证业务结果
  searchResultNotaryAction ({ commit, state }, query) {
    return new Promise((resolve, reject) => {
      searchResultApi(query).then(response => {
        if (response.status === '2000' && response.data) {
          commit('setSearchResultNotary', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 搜索常见问题结果
  searchResultArticleAction ({ commit, state }, query) {
    return new Promise((resolve, reject) => {
      searchResultApi(query).then(response => {
        if (response.status === '2000' && response.data) {
          commit('setSearchResultArticle', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 热门搜索标签
  searchHotAction ({ commit, state }, query) {
    return new Promise((resolve, reject) => {
      searchHotApi(query).then(response => {
        if (response.status === '2000' && response.data) {
          commit('setSearchHot', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setBannerList (state, bannerList) {
    state.bannerList = bannerList
  },
  setBidHot (state, bidHot) {
    state.bidHot = bidHot
  },
  setSearchResultNotary (state, searchResultNotary) {
    state.searchResultNotary = searchResultNotary
  },
  setSearchResultNotaryList (state, searchResultNotaryList) {
    state.searchResultNotaryList = searchResultNotaryList
  },
  setSearchResultArticle (state, searchResultArticle) {
    state.searchResultArticle = searchResultArticle
  },
  setSearchResultArticleList (state, searchResultArticleList) {
    state.searchResultArticleList = searchResultArticleList
  },
  setSearchHot (state, searchHot) {
    state.searchHot = searchHot
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/index/index.js